import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Plus } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ChargeLibrary = ({ onAdd }) => {
  const [charges, setCharges] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/container-charges/`)
      .then((res) => setCharges(res.data.items || []))
      .catch(() => {});
  }, []);

  if (!charges.length) return null;

  return (
    <div className="mb-4 border border-cyan-200 bg-cyan-50/50 rounded-lg p-3" data-testid="charge-library">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="text-sm font-semibold text-cyan-800 flex items-center gap-1"
        data-testid="charge-library-toggle"
      >
        <Plus size={14} /> Container Charge Library {open ? '▾' : '▸'}
        <span className="font-normal text-gray-400 ml-1">tap a charge to add it as a line item</span>
      </button>
      {open && (
        <div className="flex flex-wrap gap-2 mt-3">
          {charges.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => onAdd(c)}
              className="text-xs bg-white border border-cyan-300 hover:bg-cyan-100 text-gray-700 rounded-full px-3 py-1.5 transition-colors"
              data-testid={`charge-chip-${c.id}`}
            >
              {c.description}{c.uom && c.uom !== '%' ? ` (${c.uom})` : ''} — {c.is_percent ? `${c.default_price}%` : `$${Number(c.default_price).toFixed(2)}`}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export const chargeToLineItem = (c, currentSubtotal = 0) => {
  const pct = parseFloat(c.default_price) || 0;
  let desc = c.description;
  if (c.uom && c.uom !== '%') desc += ` (${c.uom})`;
  if (c.is_percent) {
    desc += ` @ ${pct}%`;
    const amt = +(currentSubtotal * pct / 100).toFixed(2);
    return { description: desc, lorry_no: '', quantity: 1, hours: 0, unit_price: amt, amount: amt };
  }
  const price = parseFloat(c.default_price) || 0;
  return { description: desc, lorry_no: '', quantity: 1, hours: 0, unit_price: price, amount: price };
};
